import React, { useEffect, useRef, useState } from "react";

function LazyImageCard({ img, onClick }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 } // start loading when 10% visible
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className="relative group cursor-pointer rounded-lg overflow-hidden shadow-md bg-gray-100"
      onClick={onClick}
    >
      {visible ? (
        <img
          src={img?.thumbnail + "?no-cache=" + Date.now()}
          alt="thumbnail"
          loading="lazy"
          className="w-full h-40 object-cover object-[center_30%] transform group-hover:scale-105 transition duration-300"
        />
      ) : (
        <div className="w-full h-40 flex items-center justify-center text-gray-400 text-sm">
          Loading...
        </div>
      )}
    </div>
  );
}

export default LazyImageCard;